import React from 'react'
import Layout from './layout'
import supportData from '../components/content/support/support.en-XC.yaml'
import { Link } from 'gatsby'
import { Row, Col } from '@paypalcorp/pp-react'
import { useApplicationContext } from '../provider'

export default function Support() {
  const { experiments } = useApplicationContext()
  const isInSupportExperiment =
    experiments?.supportUpdateExp?.startsWith('Trmt_') || false

  return (
    <Layout layout="full-width" title={supportData && supportData.title}>
      <section className="section under-nav-bar">
        <div className="section__content">
          <h1>{supportData.title}</h1>
          <h2 className="sr-only">{supportData.content.channelsTitle}</h2>
          <Row>
            <Col md={6} className="support-tile-margin-bottom">
              <a
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsGeneralClass}`}
                href={supportData.content.channelsGeneralLink}
              >
                <Row>
                  <Col lg={2}>
                    <img
                      className="support-icon"
                      src={supportData.content.channelsGeneralIcon}
                      alt="FAQ's"
                    />
                  </Col>
                  <Col>
                    <h3
                      className="block__title"
                      data-dxa="faq,faq-click,faq-referrer"
                    >
                      {supportData.content.channelsGeneralTitle}
                    </h3>
                    <p data-dxa="faq,faq-click,faq-referrer">
                      {supportData.content.channelsGeneralBody}
                    </p>
                  </Col>
                </Row>
              </a>
            </Col>
          </Row>
          <h4 className="support-page-subheading">Contact us</h4>
          <Row>
            <Col md={6} className="support-tile-margin-bottom">
              <a
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsAccountHelpClass}`}
                href={supportData.content.channelsAccountHelpLink}
                data-dxa="support,support-click,support-referrer"
              >
                <Row>
                  <Col lg={2}>
                    <img
                      className="support-icon"
                      src={supportData.content.channelsAccountHelpIcon}
                      alt="MTS"
                    />
                  </Col>
                  <Col>
                    <h3
                      className="block__title"
                      data-dxa="support,support-click,support-referrer"
                    >
                      {supportData.content.channelsAccountHelpTitle}
                    </h3>
                    <p data-dxa="support,support-click,support-referrer">
                      {supportData.content.channelsAccountHelpBody}
                    </p>
                  </Col>
                </Row>
              </a>
            </Col>
            <Col md={6} className="support-tile-margin-bottom">
              <a
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsSalesClass}`}
                data-dxa="support,support-click,support-referrer"
              >
                <Row>
                  <Col lg={2}>
                    <img
                      className="support-icon"
                      src={supportData.content.channelsSalesIcon}
                      alt="Sales"
                    />
                  </Col>
                  <Col>
                    <h3
                      className="block__title"
                      data-dxa="support,support-click,support-referrer"
                    >
                      {supportData.content.channelsSalesTitle}
                    </h3>
                    <p data-dxa="support,support-click,support-referrer">
                      {supportData.content.channelsSalesBody}
                    </p>
                    <ul
                      className="support-ul-margin-top"
                      data-dxa="support,support-click,support-referrer"
                    >
                      <li>{supportData.content.channelsSalesList1}</li>
                      <li>{supportData.content.channelsSalesList2}</li>
                    </ul>
                  </Col>
                </Row>
              </a>
            </Col>
            <Col md={6} className="support-tile-margin-bottom">
              <a
                className={`block block--outlined block--link block--full-height dx-no-eel-icon ${supportData.content.channelsTechClass}`}
                href={
                  isInSupportExperiment
                    ? 'https://www.paypal.com/ie/cshelp/technical'
                    : supportData.content.channelsTechnicalLink
                }
                data-dxa="support,support-click,support-referrer"
              >
                <Row>
                  <Col lg={2}>
                    <img
                      className="support-icon"
                      src={supportData.content.channelsTechnicalIcon}
                      alt="MTS"
                    />
                  </Col>
                  <Col>
                    <h3
                      className="block__title"
                      data-dxa="support,support-click,support-referrer"
                    >
                      {supportData.content.channelsTechnicalTitle}
                    </h3>
                    <p data-dxa="support,support-click,support-referrer">
                      {supportData.content.channelsTechnicalBody}
                    </p>
                  </Col>
                </Row>
              </a>
            </Col>
          </Row>
        </div>
      </section>
    </Layout>
  )
}
